import { render, staticRenderFns } from "./NovoModulo.vue?vue&type=template&id=08037592"
import script from "./NovoModulo.vue?vue&type=script&lang=js"
export * from "./NovoModulo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports